<!-- 现金支付 -->
<template>
  <div class="home">
    <!-- <van-nav-bar
			left-arrow
			fixed
			@click-left="$router.go(-1)">
		</van-nav-bar> -->
    <!-- <div class="fail">{{ $t("OrderDetail.cashPay") }}</div>
    <div class="failInfo failInfo1">
      {{ $t("OrderDetail.ticket") }}：{{ orderDetail.ticket }}
    </div>
    <div class="failInfo">
      {{ $t("OrderDetail.orderNum") }}：{{ orderDetail.order }}
    </div>
    <div class="failInfo">
      {{ $t("OrderDetail.pricePay") }}：{{ sessionStorage.getItem("currency")
      }}{{ orderDetail.final_price }}
    </div>

    <van-button @click="goOrder()" class="btn" block>{{
      $t("OrderDetail.checkOrder")
    }}</van-button> -->
    <van-nav-bar
      :style="{ background: sessionStorage.colorCode }"
      :title="$t('OrderDetail.title')"
      fixed
    >
    </van-nav-bar>
    <div class="detail_top" v-if="orderDetail">
      <div style="text-align: center; margin-top: 20px">
        <div
          class="price_icon"
          :style="{ background: sessionStorage.colorCode }"
        >
          <img src="static/img/placeOrder.png" alt="" />
        </div>
      </div>

      <div class="top_price" style="margin-top: 20px">
        {{ $t("OrderDetail.success") }}
      </div>
      <div
        class="top_price"
        style="font-size: 22px; color: #fd1211; margin-top: 20px;"
      >
        {{ $t("OrderDetail.orderNo") }}：{{ orderDetail.ticket }}
      </div>
      <div class="top_price" style="margin-top: 15px;">
        {{ $t("OrderDetail.cashPay") }}
        <span style="margin-left: 5px; font-size: 16px;">
          {{ sessionStorage.getItem("currency") }}
        </span>
        {{ orderDetail.final_price }}
      </div>
      <div class="orderNum">
        {{ $t("OrderDetail.orderNum") }}：{{ orderDetail.order }}
      </div>
      <div
        style="height: 2px; width: 100%; background-color: #cdcdcd; margin: 10px 0px;"
      ></div>
      <div style="text-align: center;">
        <van-button
          :color="sessionStorage.colorCode"
          round
          plain
          @click="goOrder"
        >
          <template #icon>
            <svg-icon
              iconClass="orderDetail"
              style="width: 25px; height: 25px;"
              class="icon"
              :style="{ color: '#fff' }"
            />
          </template>
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderDetail: {}
    };
  },
  created() {
    if (
      localStorage.onlyCode == localStorage.successCode &&
      localStorage.takeOrderId !== undefined
    ) {
      this.getOrderDetail(0);
    } else {
      this.continueOrder();
    }
  },
  methods: {
    getOrderDetail(type) {
      this.$axios({
        method: "PUT",
        url:
          this.$build + "/api/order/" + localStorage.takeOrderId + "/takeIndex"
      })
        .then(res => {
          if (res.data.status == 200) {
            this.orderDetail = res.data.data;
            if (type == 1) {
              var self = this;
              setTimeout(() => {
                self.setGoto();
              }, 500);
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    goOrder() {
      if (localStorage.onlyCode) {
        if (
          localStorage.onlyCode == localStorage.successCode &&
          localStorage.takeOrderId !== undefined
        ) {
          this.getOrderDetail(1);
        } else {
          this.$toast({
            type: "fail",
            message: this.$t("OrderDetail.noPayOrder")
          });
          var self = this;
          setTimeout(() => {
            self.continueOrder();
          }, 500);
        }
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("OrderDetail.noPayOrder")
        });
        var self = this;
        setTimeout(() => {
          self.continueOrder();
        }, 500);
      }
    },
    setGoto() {
      if (this.orderDetail.status < 2) {
        this.$toast({
          type: "fail",
          message: this.$t("OrderDetail.plsPay")
        });
        var self = this;
        setTimeout(() => {
          self.$router.push("/TakeCartDetail");
        }, 500);
      } else {
        localStorage.setItem("isPay", true);
        this.$router.push("/TakeOrderDetail/" + localStorage.takeOrderId);
      }
    },
    // 在下一单，重新获取唯一标识
    continueOrder() {
      this.$axios({
        method: "get",
        url: this.$build + "/api/shopcart/create"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            localStorage.setItem("onlyCode", res.data.code);
            var vm = this;
            // 跳转到菜品页面
            setTimeout(() => {
              vm.$router.push("/TakeDishes");
            }, 500);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-button {
  padding: 10px 50px;
}
.home {
  width: 100%;
  height: 100vh;
  background-color: #bbbbbb;
  padding-top: 56px;
}
.fail {
  text-align: center;
  margin-top: 100px;
  line-height: 40px;
  font-size: 30px;
  color: #2f75f4;
  font-weight: bold;
  background: #fff;
}

.failInfo {
  text-align: center;
  margin-top: 10px;
  line-height: 40px;
  font-size: 30px;
  color: #2f75f4;
  font-weight: bold;
  background: #fff;
}
.failInfo1 {
  font-size: 30px;
  color: #ff0000;
}
.btn {
  background: #2f75f4;
  color: #fff;
  margin: 30px auto;
  width: 50%;
  border-radius: 10px;
}
.detail_top {
  width: 90%;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 10px #979797;
  margin: 0 auto;
  padding: 5px 10px 15px;
}
.row1 {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
}
.top_price {
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  margin-top: 5px;
}
.top_success {
  width: auto;
  height: 40px;
  line-height: 40px;
  padding-right: 10px;
  display: flex;
  align-items: center;
}
.top_sit {
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  font-weight: 600;
  padding-left: 10px;
}
.price_icon {
  text-align: center;
  width: 30px;
  height: 30px;
  padding: 10px;
  display: inline-block;
  border-radius: 50%;
  border: 3px solid #000;
  position: relative;
}
.price_icon img {
  width: 28px;
  height: 23px;
  position: absolute;
  left: 22%;
  top: 23%;
}
.orderNum {
  text-align: center;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/takeAway/TakeCashPayment.vue